import { render, staticRenderFns } from "./ToCheck.vue?vue&type=template&id=635224f3&"
import script from "./ToCheck.vue?vue&type=script&lang=ts&"
export * from "./ToCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports